import React from 'react';
import CalendarDay from './CalendarDay';
import './WeeklyCalendar.css';

const WeeklyCalendar = ({ weekStart, scheduledRecipes, onRecipeRemoved, user, onScheduleSuccess }) => {
  const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  
  const generateWeekDays = () => {
    const days = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(weekStart);
      date.setDate(weekStart.getDate() + i);
      days.push(date);
    }
    return days;
  };

  const getRecipesForDate = (date) => {
    const dateStr = date.toISOString().split('T')[0];
    const filtered = scheduledRecipes.filter(schedule => schedule.scheduled_date === dateStr);
    
    // Sort by meal type: breakfast -> lunch -> dinner -> snack
    const mealTypeOrder = { breakfast: 1, lunch: 2, dinner: 3, snack: 4 };
    return filtered.sort((a, b) => {
      const orderA = mealTypeOrder[a.meal_type] || 999;
      const orderB = mealTypeOrder[b.meal_type] || 999;
      return orderA - orderB;
    });
  };

  const isToday = (date) => {
    const today = new Date();
    return date.toDateString() === today.toDateString();
  };

  const weekDays = generateWeekDays();

  return (
    <div className="weekly-calendar">
      <div className="calendar-grid">
        {weekDays.map((date, index) => (
          <CalendarDay
            key={date.toISOString()}
            date={date}
            dayName={dayNames[index]}
            scheduledRecipes={getRecipesForDate(date)}
            isToday={isToday(date)}
            onRecipeRemoved={onRecipeRemoved}
            user={user}
            onScheduleSuccess={onScheduleSuccess}
          />
        ))}
      </div>
    </div>
  );
};

export default WeeklyCalendar;